import React from 'react';
import $ from 'jquery';

import { FaEnvelope, FaPhone } from 'react-icons/fa';

class Contactsent extends React.Component {
  removeForm = () => {
    $('.form-wrapper').fadeOut(300);
  };

  render() {
    return (
      <div className="contact-wrapper" id="contact">
        <h2 className="contact-title">Kontaktujte nás</h2>
        <hr></hr>
        <div className="grid">
          <div className="maill tablet">
            <FaEnvelope className="contact-icon mail" />
            <p className="contact-icon-desc">
              <a href="mailto:D.Batka@seznam.cz">D.Batka@seznam.cz</a>
            </p>
          </div>
          <div className="phonee tablet">
            <FaPhone className="contact-icon phone" />
            <p className="contact-icon-desc">
              <a href="tel:777 337 077">777 337 077</a>
            </p>
          </div>
          <div className="mailicondiv mobile">
            <FaEnvelope className="contact-icon mail" />
          </div>
          <div className="maildiv mobile">
            <p className="contact-icon-desc">
              <a href="mailto:D.Batka@seznam.cz">D.Batka@seznam.cz</a>
            </p>
          </div>
          <div className="phoneicondiv mobile">
            <FaPhone className="contact-icon phone" />
          </div>
          <div className="phonediv mobile">
            <p className="contact-icon-desc">
              <a href="tel:777 337 077">777 337 077</a>
            </p>
          </div>
        </div>

        <div className="form-wrapper">
          <p className="mailsent-msg">Ozveme se Vám co nejdříve!</p>
        </div>
      </div>
    );
  }
}

export default Contactsent;



// WEBPACK FOOTER //
// ./src/components/Contactsent.js